import { useEffect, useState, useRef } from "react";
import { FaTimes, FaSearchPlus, FaSearchMinus, FaCloudUploadAlt, FaExchangeAlt } from "react-icons/fa";
import pathconfig from '../../pathconfig.json';
import axios from "axios";
import { toastError, toastSuccess } from '../toaster';
import Pdf from "../../images/icons/pdf.png";
import moment from 'moment';
import NodataFound from "../nodata";
import packjson from '../../../package.json';
import { useAppContextProvider } from '../../contextapi';
import { AiOutlineSync } from "react-icons/ai";

const ImagelistTab = (props) => {
    const [fileList, setFileList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [imgPathValue, setImgPathValue] = useState({});
    const [imgZoom, setImgZoom] = useState(1);
    const [texData, setTexData] = useState([]);
    const [loader, setLoader] = useState(false);
    // const fileInputRef = useRef(null);
    const modalCloseBtnRef = useRef(null);
    useEffect(() => {
        if (showModal && modalCloseBtnRef.current) {
            modalCloseBtnRef.current.focus();
        }
    }, [showModal]);
    const { fullData, setSidebarClose } = useAppContextProvider();
    const closeBtnRef = useRef(null);
    
//testing
    const [folderPath, setFolderPath] = useState('');

    useEffect(() => {
        if (fullData) {
            setTexData(fullData);
            const regex = /(?<!.)\\graphicspath\{\{([^}]*)\}\}/;
            const match = fullData.Content.match(regex);
            if (match) {
                const path = match[1];
                let changePath = path.replace(/\/$/, "");
                // getFile_details(changePath)
                setFolderPath(changePath);
                getImage_details(changePath);
            } else {
                toastError('No graphicPath found.');
                return;
            }
        }
    }, [fullData])

   useEffect(() => {    
       if (props.leftsidebarvalue === 'image' && closeBtnRef.current) {
            closeBtnRef.current.focus();
        }
    }, [props.leftsidebarvalue]);

    useEffect(() => {
        if (!showModal) return;
        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                setShowModal(false);
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [showModal]);

    const getFile_details = async (link, name) => {
        // console.log('<<<`name`>>>', name);
        
        try {
            const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_image_list}`;
            const data = { file_path: link, file_name: name };
            const response = await axios.post(url, data);
            // setFileList(response.data.Images);
            setImgPathValue(response.data.Images?.[0]);
            setLoader(false);
            // console.log(response.data.Images);
        } catch (error) {
            console.log(error);
            toastError(error.message);
            setLoader(false);
        }
    }

    const getImage_details = async (link) => {
        try {
            const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_image_details}`;
            const data = { file_path: link };
            const response = await axios.post(url, data);
            setFileList(response.data.Files);
            console.log(response.data.Files);
        } catch (error) {
            console.log(error);
            // toastError(error.message); //Commenting it for now to give production
        }
    }

    const imageView = async (val) => {
        try {
            setLoader(true);  
            setImgZoom(1);
            setImgPathValue({});   
            await getFile_details(folderPath, val.name);
            // setImgPathValue(val);
            setShowModal(true);
        } catch (error) {
            console.log(error);
            toastError('Error viewing image');
        }
    }

    const handleZoom = (type) => {
        try {
            let size = 2;
            let scaleEnd = 0.5;
            if (type === 'plus') {
                if (size !== imgZoom) {
                    setImgZoom(imgZoom + 0.5);
                }
            } else {
                if (scaleEnd !== imgZoom) {
                    setImgZoom(imgZoom - 0.5);
                }
            }
        } catch (error) {
            console.log(error);
            toastError('Error adjusting zoom');
        }
    }

    const handleFileReupload = (e) => {
        setLoader(true)
        try {
            var formdata = new FormData();
            const oversizedFiles = [];
            const maxFileSize = 40 * 1024 * 1024; // 40MB in bytes
            const validFiles = [];
            
            // Get the list of files from local folder
            const localFiles = fileList.map(file => file.name);
    
            // Process each selected file
            for (const file of e.target.files) {
                if (file.size > maxFileSize) {
                    oversizedFiles.push(file.name);
                } else {
                    // If file exists in local folder, use that name instead
                    const existingFile = localFiles.find(localFile => 
                        localFile.toLowerCase().split('.')[0] === file.name.toLowerCase().split('.')[0]
                    );
                    
                    if (existingFile) {
                        // Create new file object with existing name
                        const renamedFile = new File([file], existingFile, {
                            type: file.type,
                            lastModified: file.lastModified,
                        });
                        validFiles.push(renamedFile);
                    } else {
                        validFiles.push(file);
                    }
                }
            }
    
            validFiles.forEach(file => formdata.append("files", file));
    
            if (oversizedFiles.length > 0) {
                toastError(`File size should be less than 40 MB: ${oversizedFiles.join(', ')} `);
                setLoader(false);
                if (validFiles.length === 0) {
                    e.target.value = null;
                    return;
                }
            }
    
            const regex = /(?<!.)\\graphicspath\{\{([^}]*)\}\}/;
            const match = texData.Content.match(regex);
            if (match) {
                const path = match[1];
                formdata.append("path", path);
            } else {
                toastError('No graphicPath found.');
                return;
            }
    
            const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].figureAttachment}`;
            axios.post(url, formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then((response) => {
                if (response.data.success === true) {
                    toastSuccess(`${response.data.message}`);
                    setLoader(false);
                    props.getTrigger(true);
                }
            }).catch(error => {
                console.log(error);
                toastError(error.message);
                setLoader(false);
            });
        } catch (error) {
            console.log(error);
            toastError('Error uploading file');
            setLoader(false);
        }
        e.target.value = null;
    }
    
    
    const handleSingleFileReplace = (e, fileName) => {
        setLoader(true);
        try {
            var formdata = new FormData();
            const file = e.target.files[0];
            const maxFileSize = 40 * 1024 * 1024;
    
            if (file.size > maxFileSize) {
                toastError(`File size should be less than 40 MB`);
                setLoader(false);
                return;
            }

            if (!file.name.endsWith('.pdf')) { // Check for .pdf format
                toastError(`Invalid file format: ${file.name}. Only .pdf files are allowed.`);
                setLoader(false);
                e.target.value = null; // Clear the input
                return;
            }
    
            // Create new File object with the name from the row
            const renamedFile = new File([file], fileName, {
                type: file.type,
                lastModified: file.lastModified,
            });
    
            formdata.append("files", renamedFile);
            
            const regex = /(?<!.)\\graphicspath\{\{([^}]*)\}\}/;
            const match = texData.Content.match(regex);
            if (match) {
                const path = match[1];
                formdata.append("path", path);
                formdata.append("replaceFile", fileName);
            } else {
                toastError('No graphicPath found.');
                return;
            }
    
            const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].figureAttachment}`;
            
            axios.post(url, formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then((response) => {
                if (response.data.success === true) {
                    toastSuccess(`${response.data.message}`);
                    setLoader(false);
                    props.getTrigger(true);
                }
            }).catch(error => {
                console.log(error);
                toastError(error.message);
                setLoader(false);
            });
        } catch (error) {
            console.log(error);
            toastError('Error replacing file');
            setLoader(false);
        }
        e.target.value = null;
    }
    
    const openPdfInNewTab = () => {
        if (!folderPath || !imgPathValue?.name) return;

        const baseUrl = pathconfig[packjson.environment].baseUrl;
        const viewPdfPath = pathconfig[packjson.environment].viewFigurePDF;

        const url =
            `${baseUrl}${viewPdfPath}` +
            `?file_path=${encodeURIComponent(folderPath)}` +
            `&file_name=${encodeURIComponent(imgPathValue.name)}`;

        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <section className="image-list-area" aria-labelledby="highResImageListHeading">
            {Object.keys(imgPathValue).length ?
                <div className={`modal-outer ${showModal ? 'active' : ''}`} >
                    <div className="modal modal-zoom-fix" style={{ width: '800px' }}>
                        <div className="modal-header">
                            Image Preview - {imgPathValue.name.split('.')[0]}             
                            <button
                                className="view-pdf-btn"
                                title="View high-resolution PDF"
                                onClick={openPdfInNewTab}
                            >
                                View High-Res Image
                            </button>
                            <button
                                className="closebtn"
                                title="Close"
                                tabIndex={0}
                                ref={modalCloseBtnRef}
                                onClick={() => setShowModal(false)}
                            >
                                <FaTimes />
                            </button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '525px', overflow: 'hidden', position: 'relative' }}>
                            <div className="image-preview-area">
                                <button tabIndex={0} onClick={() => handleZoom('plus')}><FaSearchPlus /></button>
                                <button tabIndex={0} onClick={() => handleZoom('minus')}><FaSearchMinus /></button>
                            </div>
                            <div className="img-preview-area">
                                {loader ? (
                                    <div className="fileupload-loder">
                                    <span className="loader"></span>
                                    </div>                                
                                    ) : (
                                    <img
                                        src={imgPathValue.thumbnail_base64}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            transform: `scale(${imgZoom})`,
                                            transformOrigin: '0 0'
                                        }}
                                        alt={imgPathValue.name?.split('.')[0]}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div> : ""}
            <div className="slider-header">
                <h2 id="highResImageListHeading">Image List</h2>
                <div>
                    <button
                        className="close-btn"
                        title="Close"
                        tabIndex={0}
                        ref={closeBtnRef}
                        onClick={() => {
                            setSidebarClose(true);
                            // After closing, return focus to the Image tab button
                            setTimeout(() => {
                                const imgBtn = document.getElementById('image-tab-btn');
                                if (imgBtn) imgBtn.focus();
                            }, 0);
                        }}
                        onKeyDown={e => {
                            // If Enter or Space, close and focus Image tab
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setSidebarClose(true);
                                setTimeout(() => {
                                    const imgBtn = document.getElementById('image-tab-btn');
                                    if (imgBtn) imgBtn.focus();
                                }, 0);
                                return;
                            }
                            if (e.key === 'Tab' && !e.shiftKey && (loader || fileList.length === 0)) {
                                e.preventDefault();
                                const suppBtn = document.getElementById('supplementary-tab-btn');
                                if (suppBtn) suppBtn.focus();
                            }
                        }}
                    >
                        <FaTimes />
                    </button>
                </div>
            </div>
            <div className="upload-list-area">
                {fileList.length !== 0 ? fileList.map((item, index) =>
                    <div className="upload-list-area-inner" key={index} style={{ display: 'flex' }}>
                        <div className="upload-icons" onClick={() => imageView(item)} style={{ cursor: 'pointer' }} onKeyDown={(e) => { if (e.key === 'Enter') imageView(item); }}>
                            <img src={Pdf} alt='file' />
                        </div>
                            <div
                                className="upload-details"
                                onClick={() => imageView(item)}
                                style={{ cursor: 'pointer' }}
                                role="button"
                                tabIndex={0}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') imageView(item);
                                    // If this is the last image, Tab should go to Supplementary tab
                                    if (
                                        e.key === 'Tab' &&
                                        !e.shiftKey &&
                                        Array.isArray(fileList) &&
                                        index === fileList.length - 1
                                    ) {
                                        e.preventDefault();
                                        const suppBtn = document.getElementById('supplementary-tab-btn');
                                        if (suppBtn) suppBtn.focus();
                                    }
                                }}
                            >
                          <p title={item.name.split('.')[0]}>{item.name.split('.')[0]}</p>
                          {/* <span>Date: {moment(item.CreatedOn).format("DD MMM YY")}</span> */}
                          <span>Date: {moment(item.uploaded_at).format("DD MMM YY")}</span>
                        </div>
                        {/* <div className="replace-icon" onClick={(e) => e.stopPropagation()}>
                            <label className="replace-label">
                                <AiOutlineSync  title="Replace Image" />
                                <input 
                                    type="file" 
                                    accept=".pdf"
                                    onChange={(e) => handleSingleFileReplace(e, item.name)}
                                    style={{ display: 'none' }}
                                />
                            </label>
                        </div> */}
                    </div>
                ) : <NodataFound />}
            </div>
            {/* <div className="reupload-area">
                <div className="reupload-area-inner">
                    <FaCloudUploadAlt />
                    <p>add or reupload - Choose file or drag here</p>
                    <input type="file" accept=".pdf" onChange={(e) => handleFileReupload(e)} multiple ref={fileInputRef}></input>
                </div>
            </div> */}
        </section>
    )
}
export default ImagelistTab;